document.addEventListener("DOMContentLoaded", () => {
  // ---------- Config ----------
  const COLLECTION_HANDLE = "oddballs-x-joe";
  const GIFT_VARIANT_ID   = 40610504376381;
  const GIFT_PROPERTY     = "_joesGift";
  const MAX_PAGES         = 20;
  const SESSION_VARIABLE = "joe"

  const params = new URLSearchParams(window.location.search);
  if (params.get("joeballs")) sessionStorage.setItem(SESSION_VARIABLE, "true");

  let collectionIds = null; // cached for the session
  let inFlight = false;
  let queued   = false;

  async function getCollectionProductIds() {
    if (collectionIds) return collectionIds;
    const ids = new Set();
    for (let page = 1; page <= MAX_PAGES; page++) {
      const res = await fetch(`/collections/${COLLECTION_HANDLE}/products.json?limit=250&page=${page}`);
      if (!res.ok) break;
      const { products = [] } = await res.json();
      if (products.length === 0) break;
      products.forEach(p => ids.add(p.id));
    }
    collectionIds = ids;
    return ids;
  }

  // Only lines we added carry the property, so we never touch a gift
  // variant the customer put in the cart themselves.
  const isGiftLine = item => Boolean(item.properties && item.properties[GIFT_PROPERTY]);

  const getCart = () => fetch("/cart.js").then(r => r.json());

  const addGift = () =>
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{
          id: GIFT_VARIANT_ID,
          quantity: 1,
          properties: { [GIFT_PROPERTY]: "true" }
        }]
      })
    });

  // update.js takes line item keys, so multiple lines go in one request
  const applyUpdates = updates =>
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates })
    });

  async function syncGift() {
    if (inFlight) { queued = true; return; }
    inFlight = true;

    let changed = false;

    try {
      const cart = await getCart();
      const giftLines = cart.items.filter(isGiftLine);

      // Nothing in the cart at all — nothing to do, and no need to crawl the collection.
      if (cart.items.length === 0) return;

      const ids = await getCollectionProductIds();
      const qualifies = cart.items.some(i => !isGiftLine(i) && ids.has(i.product_id));
      const hasRemoved = sessionStorage.getItem("removedJoe")
      const sessionQualifies = sessionStorage.getItem(SESSION_VARIABLE)

      if (qualifies && !hasRemoved && sessionQualifies) {
        if (giftLines.length === 0) {
          await addGift();
          changed = true;
        } else {
          // Keep the first gift line at qty 1, zero out any duplicates.
          const updates = {};
          giftLines.forEach((line, i) => {
            const target = i === 0 ? 1 : 0;
            if (line.quantity !== target) updates[line.key] = target;
          });
          if (Object.keys(updates).length) {
            await applyUpdates(updates);
            changed = true;
          }
        }
      } else if (giftLines.length) {
        const updates = {};
        giftLines.forEach(line => { updates[line.key] = 0; });
        await applyUpdates(updates);
        changed = true;
      }
    } catch (err) {
      console.error("gift sync failed:", err);
    } finally {
      inFlight = false;
      if (changed) document.dispatchEvent(new CustomEvent("refreshDrawer"));
      if (queued) { queued = false; syncGift(); }
    }
  }

  document.addEventListener("checkJoe", syncGift);
  document.addEventListener("cart:updated", syncGift); // wire to whatever your theme fires

  syncGift();
});